import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Login, { ROLES } from './Login';
import Scan from './Scan';
import PageLoader from './components/PageLoader';
import PullToRefresh from './components/PullToRefresh';
import './theme';

// Route /scan : UI dédiée scan barista (accessible depuis le dashboard via
// le bouton SCAN sur mobile).
const IS_SCAN_ROUTE = typeof window !== 'undefined' &&
  window.location.pathname.replace(/\/+$/, '').toLowerCase() === '/scan';

function Root() {
  return (
    <>
      <PullToRefresh />
      {IS_SCAN_ROUTE ? <Scan /> : <Dashboard />}
    </>
  );
}

function Dashboard() {
  // null = chargement initial / false = non connecté / objet = session
  const [session, setSession] = useState(null);
  const [checked, setChecked] = useState(false);

  // Vérifie la session via le cookie httpOnly au démarrage
  useEffect(() => {
    // Bypass dev désactivé : avec `vercel dev`, les API tournent et exigent un cookie
    // de session — il faut donc passer par le vrai Login pour qu'elles répondent 200.
    // (Réactiver `setSession({ role: 'admin' })` UNIQUEMENT si on relance via `npm start` seul.)
    fetch('/api/me', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data && ROLES[data.role]) setSession(data);
      })
      .catch(() => {})
      .finally(() => setChecked(true));
  }, []);

  const handleLogout = async () => {
    try {
      await fetch('/api/logout', { method: 'POST', credentials: 'same-origin' });
    } catch (_) {}
    setSession(null);
  };

  const refreshSession = async () => {
    try {
      const r = await fetch('/api/me', { credentials: 'same-origin' });
      if (r.ok) {
        const data = await r.json();
        if (data && ROLES[data.role]) setSession(data);
      }
    } catch (_) {}
  };

  if (!checked) return <PageLoader />;

  if (!session) {
    return <Login onAuth={(data) => setSession(data)} />;
  }

  return <App session={session} role={session.role} onLogout={handleLogout} onSessionRefresh={refreshSession} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

// PWA : enregistre le SW en production pour rendre l'app installable
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
